<div class="container">
  <input
    matInput
    type="text"
    autocomplete="off"
    [formControl]="searchValue"
    (keyup)="search()"
    placeholder="Buscar por criptomoneda"
  />
  <div class="search-icon" *ngIf="searchValue.value.length > 0">
    <img
      class="icon"
      src="assets/icons/trash-can.svg"
      alt=""
      (click)="searchValue.setValue(''); search()"
    />
  </div>
</div>
<!-- <mat-form-field class="example-form-field" appearance="outline">
  <button *ngIf="value" matSuffix mat-icon-button aria-label="Clear" (click)="search()">
    <mat-icon>close</mat-icon>
  </button>
</mat-form-field> -->
